
export default (pageContext) => {
  const {article} = pageContext.data
  return article?.title + " | Seedr " + article?.category
}
